import { apiClient } from '~/api';
import type { Device, Locale } from '~/types';
import type { BlogArticlePageData } from '~/types/pages/blogArticlePageData';

export default async function getBlogArticlePage(payload: Payload) {
  const a11Store = useA11yStore();
  const { enabled: a11yEnabled } = storeToRefs(a11Store);
  const headers = a11yEnabled.value ? { 'a11y-enabled': 'true' } : undefined;

  return await apiClient<BlogArticlePageData>('/pages/blog-article-page', {
    cacheKey: getApiRequestCacheKey('blogArticlePage', {
      ...payload,
      a11y: Boolean(a11yEnabled.value).toString(),
    }),
    params: payload,
    headers,
  });
}

interface Payload {
  slug: string;
  locale: Locale;
  device: Device;
}
